export const API_HOST = 'http://localhost:3000/v1/'
// export const API_HOST = 'https://sandbox.api.fakturnia.pl/v1/'
export const settings = {
    version: require('../../package.json').version + 'dev',
    facebookUrl: 'https://facebook.com/fakturniapl',
    emailAddress: 'kontakt@fakturnia.pl',
    accessTokenKey: 'access_token',
    refreshTokenKey: 'refresh_token',
    sessionIdKey: 'session_id',
    ksefEnabled: true,
    ksefQrVerifyUrl: 'https://qr-test.ksef.mf.gov.pl/invoice',
    enableSubscriptions: false,
    enableRestAPI: true
}